import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

/**
 * Goes back to wherever the reader actually came from.
 *
 * This replaced fixed "All updates" / "All posts" / "All policies" links, which always
 * dumped the reader on a list page even when they had arrived from Home, a notification
 * or a search result — losing their place every time.
 *
 * `fallback` matters: with no in-app history (a deep link, a new tab, a shared URL, a
 * refresh) navigate(-1) would walk OUT of the site. React Router stamps an index onto
 * history.state, so idx > 0 tells us there is somewhere of our own to go back to; when
 * there isn't, we send them to the section's list instead of off the site.
 */
const BackButton = ({ fallback = "/", label = "Back" }) => {
    const navigate = useNavigate();

    const goBack = () => {
        if (window.history.state?.idx > 0) navigate(-1);
        else navigate(fallback);
    };

    return (
        <button type="button" className="back-link" onClick={goBack}>
            <FaArrowLeft aria-hidden="true" /> {label}
        </button>
    );
};

export default BackButton;
